import Backbone from 'backbone';
import $ from 'jquery';

module.exports = Backbone.View.extend({
  className: 'view-port',
  constructor: function ListView(options) {
    _.bindAll(
      this,
      'scrollToBottom',
      'animateScrollTo',
      'handleScroll',
      'setupListeners'
    );
    options = options || {};

    this.setupListView(options);
    this.setupListeners();

    //super call - default Backbone magic
    Backbone.View.call(this, options);
  },

  initialize(o) {
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
  },

  setupListView(options) {
    _.defaults(options, {
      itemView: Backbone.View,
      collection: new Backbone.Collection()
    });
    this.itemView = options.itemView;
    this.collection = options.collection;
    this.parent = options.parent;
  },

  setupListeners: function() {
    this.listenTo(this.collection, 'add', this.addItem, this);
    // this.listenTo(this.collection, "reset", this.addAll, this);
    // this.listenTo(this.collection, "remove", this.removeSingleItem, this);
  },

  clear() {
    this.collection.reset();
    this.listView.html('');
  },

  addAll: function() {
    // remove previous items if present
    // this.removeAllItems();
    // reinit all listeners
    // this.setupListeners();
    //add new items
    this.collection.each(function(model) {
      this.addItem(model);
    }, this);
  },

  addItem: function(model, option) {
    const { listView, $el, trigger } = this;
    const that = this;
    var index = this.collection.indexOf(model);
    var viewItem = new this.itemView({
      model: model
    });
    viewItem.render();
    const children = listView.children();
    if (index >= children.length) {
      listView.append(viewItem.el);
      if (
        model.attributes.displayChat &&
        listView.height() <= $el.height() - 20 &&
        model.attributes.type == 2
      ) {
        that.trigger('scrollBottom');
      }
    } else {
      viewItem.$el.insertBefore(children[index]);
    }
    // check read model
    const read = model.get('read');
    if (!read) {
      setTimeout(() => {
        const isInViewPort = that.checkItemInViewPort(model);
        model.set('read', isInViewPort);
        if (isInViewPort) {
          that.trigger('onItemsRead', [model]);
        } else {
          that.trigger('onItemsUnread', [model]);
        }
      }, 150);
    }
    return viewItem;
  },

  checkItemInViewPort(model) {
    const { el, $el, listView } = this;
    const rect = el.getBoundingClientRect();
    const index = this.collection.indexOf(model);
    const vpHeight = $el.height();
    const children = listView.children();
    const $item = children.length > index && children[index];
    if (!$item) {
      return true;
    }
    const itemRec = $item.getBoundingClientRect();
    const itemDistance = itemRec.top - rect.top;
    if (itemDistance > vpHeight) {
      return false;
    }
    return true;
  },

  scrollToBottomNotAnimate() {
    const { el, $el, listView } = this;
    el.scrollTop = listView.height() - Number($el.innerHeight());
  },

  scrollTo(height) {
    const { el } = this;
    el.scrollTop = height;
  },

  checkBottomScroll() {
    const { el, $el, listView } = this;
    const scrollTop = Number(el.scrollHeight) - Number($el.innerHeight());
    const isBottom = Number(el.scrollTop) >= scrollTop - 100 ? true : false;
    return isBottom;
  },

  getCurrentScrollTop() {
    const { el } = this;
    return this.startScrollTop;
  },

  scrollToBottom() {
    const { el, $el, listView } = this;
    el.scrollTop = listView.height() - Number($el.innerHeight());
    // if (this.globalID) {
    //   cancelAnimationFrame(this.globalID);
    //   this.globalID = null;
    // }

    // this.scrollFinishAt = Date.now() + 200;
    // requestAnimationFrame(this.animateScrollTo);
  },

  animateScrollTo() {
    const { el, $el, listView } = this;
    const currentTop = el.scrollTop;
    const height = $el.height();
    const scrollBottom = listView.height() - height;
    if (scrollBottom < 0) {
      return;
    }
    const framesLeft = (this.scrollFinishAt - Date.now()) / 16.6;
    const distance = scrollBottom - currentTop;
    const delta = Math.max(1, distance / framesLeft);
    el.scrollTop = currentTop + delta;
    if (el.scrollTop >= scrollBottom || el.scrollTop === currentTop) {
      el.scrollTop = listView.height();
      if (this.globalID) {
        cancelAnimationFrame(this.globalID);
        this.globalID = null;
      }
      return;
    }
    this.globalID = requestAnimationFrame(this.animateScrollTo);
  },

  handleScroll() {
    const self = this;
    const height = this.$el.height();
    const scrollBottom = this.listView.height() - height;

    if (this.scrollEndTimer) {
      clearTimeout(this.scrollEndTimer);
    }
    this.scrollEndTimer = setTimeout(function() {
      self.handleOnScrollEnd(scrollBottom);
    }, 150);
  },

  handleOnScrollEnd(scrollBottom) {
    const { $el, el, model, collection } = this;
    if (el.scrollTop <= 5) {
      this.trigger('onScrollTop');
    }
    if (el.scrollTop >= scrollBottom) {
      this.trigger('scrollBottom');
    }

    this.checkReadItems();
  },

  handleStartScroll() {
    this.startScrollTop = el.scrollTop;
  },

  checkReadItems() {
    const self = this;
    const { collection } = this;
    let unreadList = collection.filter(function(model) {
      return !model.get('read');
    });
    unreadList.forEach(model => {
      const isInViewPort = self.checkItemInViewPort(model);
      if (isInViewPort) {
        model.set('read', true);
        self.trigger('onItemsRead', [model]);
      }
    });

    unreadList = unreadList.filter(function(model) {
      return !model.get('read');
    });
    self.trigger('onItemsUnread', unreadList);
  },

  render: function() {
    const { $el, el, parent } = this;
    this.listView = $(`<div class="list-view"></div>`);
    $el.append(this.listView);
    this.addAll();
    $(parent).append(el);
    $el.on('scroll', this.handleScroll);
    $el.on('scrollstart', this.handleStartScroll);

    return this;
  }
});
